(() => {
  if (customElements.get("intro-layer")) return;

  class IntroLayer extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this.overlay = null;
      this.content = null;
      this.isLocked = false;
      this.handleReveal = this.handleReveal.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector("[data-intro-trigger]");
      this.overlay = this.querySelector("[data-intro-overlay]");
      this.content = this.querySelector("[data-intro-content]");

      if (this.trigger) {
        this.trigger.addEventListener("click", this.handleReveal);
      }

      if (this.dataset.state !== "revealed") {
        this.lockScroll();
      }
    }

    disconnectedCallback() {
      if (this.trigger) {
        this.trigger.removeEventListener("click", this.handleReveal);
      }

      this.unlockScroll();
    }

    handleReveal() {
      this.reveal();
    }

    reveal() {
      this.dataset.state = "revealed";

      if (this.overlay) {
        this.overlay.setAttribute("aria-hidden", "true");
        this.overlay.inert = true;
      }

      if (this.content) {
        this.content.setAttribute("aria-hidden", "false");
      }

      this.unlockScroll();
    }

    lockScroll() {
      if (this.isLocked) return;
      this.isLocked = true;
      document.documentElement.classList.add("intro-layer--locked");
      document.body.classList.add("intro-layer--locked");
    }

    unlockScroll() {
      if (!this.isLocked) return;
      this.isLocked = false;
      document.documentElement.classList.remove("intro-layer--locked");
      document.body.classList.remove("intro-layer--locked");
    }
  }

  customElements.define("intro-layer", IntroLayer);
})();
